import { Component, Injector, ElementRef, ViewChild, OnInit } from '@angular/core';
import { UserService } from 'src/app/service/UserService';
import { BaseComponent } from '../../common/BaseComponent';
import { Observable, Subscription } from 'rxjs';
import { UserRoleDetails } from 'src/app/model/userRoleDetails';
import { User } from 'src/app/model/user';
import { AdminService } from 'src/app/service/admin/AdminService';
import { ProgressService } from 'src/app/service/ProgressService';
import { Constants } from 'src/app/util/Constants';
@Component({
  selector: 'app-admin-reset-password',
  templateUrl: './reset-password.component.html',
  styles: [
  ]
})
export class AdminResetPasswordComponent extends BaseComponent implements OnInit {
  services: any[];
  currentLanguage: string;
  restSub: Subscription;
  private languageChangeSubs: Subscription;
  dataSubscription: Subscription;
  userRoleDetails: UserRoleDetails;
  pageMsgRendered: boolean;
  user: User;
  isMPRADMIN: boolean = false;
  roles: any;
  email: string;
  operation: number;
  emailAccess: number;
  checkboxValue: boolean = false;
  appErrorPrefix: string = "bss.api.error";
  @ViewChild('progressDialog') progressDialogElementRef!: ElementRef<HTMLDialogElement>;

  constructor(
    injector: Injector,
    public rest: AdminService,
    public restUser: UserService,
    public progressService: ProgressService
  ) {
    super(injector);
  }
  ngOnInit(): void {

    this.currentLanguage = this.translator.currentLang;
    this.subscribeToLanguageChange();
    const sessionUserRole = sessionStorage.getItem("selectedUserRole");
    this.userRoleDetails = JSON.parse(sessionUserRole);
    this.user = this.userRoleDetails.user;

    this.restUser.getUserRoles(this.user).subscribe(response => {
      console.log("send-email:" + JSON.stringify(response));
      if (response['result'] > 0) {
        this.appError = true;
        this.appErrorMessage = this.getMessage(this.appErrorPrefix + "." + response['error_code']);
      } else {
        this.appError = false;
        this.roles = response['enrolledroles'];
        if (this.roles.includes(Constants.BPS_MPR_ADMIN)) {
          this.isMPRADMIN = true;
        }
      }
    }, (error) => { this.processError(error) });

  }
  private subscribeToLanguageChange(): void {
    this.languageChangeSubs = this.translator.onLangChange.subscribe(
      () => {
        this.currentLanguage = this.translator.currentLang;
      }
    );
  }

  ngOnDestroy() {

    if (this.languageChangeSubs) {
      this.languageChangeSubs.unsubscribe();
    }
  }

  resetPassword(operation: number) {
    this.email = this.user.email;
    this.emailAccess = this.checkboxValue ? 1 : 0;
    this.progressService.open();
    this.restSub = this.rest.resetPassword(this.email, operation, this.emailAccess).subscribe(response => {
      console.log("get-data:" + JSON.stringify(response));
      this.isSubmitting = false;
      if (response.result == 1) {
        this.appError = true;
        this.appErrorMessage = this.appErrorPrefix + "." + response.error_code;
      } else {
        this.appError = false;
        sessionStorage.setItem('operation', operation.toString());
        sessionStorage.setItem('code', response.code)
        this.router.navigate(['secure/paddmin/resetpassword/complete']);
      }
    }, (error) => {
      this.processError(error);
    },
      () => {
        this.progressService.close();
      });



    // this.router.navigate(['secure/paddmin/resetpassword/complete']);

  }
  ngAfterViewInit() {
    this.progressService.setDialog(this.progressDialogElementRef.nativeElement);
  }
  onCancel(): void {
    this.router.navigate(['secure/paadmin/roleMemship']);
  }
  setAccess():void{
    this.router.navigate(['secure/paddmin/manageuseremailaccess']);
  }

}